import {lazy} from '@aboutyou/lazy-imports';
import React from 'react';
import {HomePageSkeleton} from './HomePageSkeleton';

export const HomePage = lazy(
  () => import('./HomePage.eager').then(mod => ({default: mod.HomePage})),
  {
    fallback: <HomePageSkeleton />,
    aboveTheFold: true,
    isSsrAndNeedsHydration: true,
  },
);
